import React, { useEffect, useState } from "react";
import { FiEdit } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { Axios } from "../../Axios";
import { BASE_URL } from "../../Axios/base_url";
import { calendarTime } from "../../assets/svgIcons";
import UseGeneral from "../../hooks/useGeneral";
import { ThreeDots } from "react-loader-spinner";

import "./right.css";

export const Right = ({
  setSelectedLocations,
  locations,
  setpay_type,
  setorder_time,
  setdelivary_type,
  delivary_type,
  setActiveLocation,
  activeLocation,
  cardInfo,
  setCardInfo,
  userOrderInfo,
  setUserOrderInfo,
  setchoose_subs,
  choose_subs,
  userLoading,
  enterAddressModal,
  setEnterAddressModal,
  setOpenSetWalletValue,
  payType,
  setWalletValue,
}) => {
  useEffect(() => {
    setdelivary_type("quickly");
  }, []);
  const { language } = UseGeneral();
  const navigate = useNavigate();
  const [cartData, setCartsData] = useState([]);

  const [cartTotalPrice, setCartTotalPrice] = useState(0);
  const [paymentOpen, setPaymentOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [payCheckbox, setPayCheckbox] = useState(true);
  const [payWalletBox, setPayWalletBox] = useState(false);
  const [payTwoTypesBox, setPayTwoTypesBox] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [date, setDate] = useState("");
  const [diableInputs, setDisableInputs] = useState(true);

  // const [locations, setLocations] = useState([]);

  const handleCheckboxChange = (option) => {
    setSelectedOption(option);
  };
  const handleOpenPayment = () => {
    setPaymentOpen(!paymentOpen);
    setPayCheckbox(paymentOpen ? false : false);
  };
  const handlePayCheckboxChange = (e) => {
    const { checked, value } = e?.target;
    if (checked) {
      setPayCheckbox(!payCheckbox);
      setpay_type("cash_on_delivery");
      setPayTwoTypesBox(false);
      setPayWalletBox(false);
      setPaymentOpen(checked ? false : false);
    }
  };

  const handlePayUsingWalletBox = (e) => {
    const { checked, value } = e?.target;
    if (checked) {
      setpay_type("wallet");
      setPayCheckbox(false);
      setPayTwoTypesBox(false);
      setPayWalletBox(!payWalletBox);
      setPaymentOpen(checked ? false : false);
    }
  };

  const handlePayTwoWaysBox = (e) => {
    const { checked, value } = e?.target;
    if (checked) {
      setpay_type("wallet_and_cash");
      setPayCheckbox(false);
      setPayWalletBox(false);
      setPayTwoTypesBox(!payTwoTypesBox);
      setPaymentOpen(checked ? false : false);
    }
  };

  useEffect(() => {
    setOpenSetWalletValue(false);
    if (setWalletValue) setWalletValue(null);
  }, [payType]);
  const getUserData = () => {
    setPageLoading(true);
    Axios({
      url: BASE_URL + "cart/all_carts_for_user",
      method: "GET",
    })
      .then((res) => {
        if (res.message == "Sission Ended Login Again") {
          // toast.error(res.message);
        }
        if (Array.isArray(res.result)) {
          setCartsData(res.result);
        }
      })
      .finally(() => {
        setPageLoading(false);
      });
  };

  const [offlineUserAddress, setOfflineUserAddress] = useState({});

  const getOfflineUserAddress = () => {
    const offlineUserAddressData = JSON.parse(
      localStorage.getItem("offlineUserAddress")
    );
    setOfflineUserAddress(offlineUserAddressData);
  };
  const isThereIsToken = localStorage.getItem("GreenTreesToken");
  useEffect(() => {
    getUserData();
    // getUserLocations()
    // getMeData()
  }, []);

  useEffect(() => {
    getOfflineUserAddress();
  }, [activeLocation]);

  return (
    <div className="right-container">
      <div className="pay-map-container">
        <div className={language == "ar" ? "row" : "row rev_row"}>
          <div className="title">
            <h1>
              {language == "ar" ? "البيانات الرئيسيه" : "Main Information"}
            </h1>
            <div className="icon-container">
              <FiEdit
                style={{
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (!localStorage.getItem("GreenTreesToken")) {
                    setEnterAddressModal(true);
                    return;
                  }
                  setDisableInputs(!diableInputs);
                }}
              />
            </div>
          </div>

          {!userLoading ? (
            <div className="content">
              <div className="d-flex inputs">
                <strong>{language == "ar" ? "الاسم" : "Name"}: </strong>
                <input
                  style={{
                    // border: diableInputs ? "none" : "1px solid #ccc",
                    borderRadius: "4px",
                    flex: "1",
                  }}
                  disabled
                  onChange={(e) => {
                    setUserOrderInfo({
                      ...userOrderInfo,
                      name: e.target.value,
                    });
                  }}
                  type="text"
                  value={userOrderInfo && userOrderInfo?.name}
                />
              </div>
              <div className="d-flex inputs">
                <strong>{language == "ar" ? "الرقم" : "Phone"}: </strong>
                <input
                  onChange={(e) => {
                    setUserOrderInfo({
                      ...userOrderInfo,
                      phone: e.target.value,
                    });
                  }}
                  style={{
                    // border: diableInputs ? "none" : "1px solid #ccc",
                    borderRadius: "4px",
                    flex: "1",
                  }}
                  disabled
                  type="text"
                  value={userOrderInfo && userOrderInfo?.phone}
                />
              </div>
              <div className="d-flex">
                <strong>{language == "ar" ? "العنوان" : "location"}: </strong>

                {!localStorage.getItem("GreenTreesToken") &&
                localStorage.getItem("offlineUserAddress") ? (
                  <span>
                    {offlineUserAddress?.region_ar}/{offlineUserAddress?.city} /{" "}
                    {offlineUserAddress?.district} /{offlineUserAddress?.streat}{" "}
                    /{offlineUserAddress?.architecture} /
                    {offlineUserAddress?.floor} /{offlineUserAddress?.apartment}{" "}
                    /{offlineUserAddress?.special_marque} /
                    {offlineUserAddress?.location}
                  </span>
                ) : (
                  <select
                    onChange={(e) => {
                      setActiveLocation(e.target.value);

                      setSelectedLocations(
                        locations?.filter(
                          (item) => item?.id == e.target.value
                        )[0]
                      );
                    }}
                    disabled={diableInputs}
                    style={{
                      border: diableInputs ? "none" : "1px solid #ccc",
                      borderRadius: "4px",
                      flex: "1",
                      backgroundColor: "transparent",
                    }}
                    value={activeLocation}
                    name=""
                    id=""
                  >
                    {locations?.map((item, index) => {
                      return (
                        <option value={item.id}>
                          {" "}
                          {language == "ar"
                            ? item?.region_data?.title_ar
                            : item?.region_data?.title_en}
                        </option>
                      );
                    })}
                  </select>
                )}

                {/* <input style={{
                border:diableInputs?'none':'1px solid #ccc',
                borderRadius:'4px',
                flex:'1'
              }} disabled={diableInputs} type="text" value={userOrderInfo?.location} /> */}
              </div>
            </div>
          ) : (
            <ThreeDots />
          )}
        </div>
        <div className={language == "ar" ? "row" : "row rev_row"}>
          <div className="title">
            {/* <h1>{language == "ar" ? "توصيل" : "Delivery"}</h1> */}
            {/* <div className="icon-container">
              <FiEdit />
            </div> */}
          </div>
          <div className="content">
            <div className="checkBox-container">
              {/* <label
                onClick={() => {
                  setdelivary_type("quickly");
                }}
                class="checkBox"
              >
                <input
                  id="ch1"
                  type="checkbox"
                  checked={delivary_type == "quickly"}
                />
                <div class="transition"></div>
              </label>{" "} */}
              <div>
                {/* <h6>{language == "ar" ? "فى اسرع وقت" : "Quickly"}</h6> */}
                <span style={{ fontWeight: 800 }}>
                  {language == "ar"
                    ? "1 يوم عمل داخل الإمارات"
                    : "Within 24 hours Delivery Inside UAE"}
                </span>
                <p style={{ fontWeight: 800 }}>
                  {language == "ar"
                    ? "3 يوم عمل إلى عمان"
                    : "Within 72 hours Delivery To Oman"}
                </p>
              </div>
            </div>
            {/* <label
              htmlFor='date'
              style={{cursor: "pointer"}}
              onClick={() => {
                setdelivary_type("time");
              }}
              className='d-flex'
            >
              <div className='icon'>{calendarTime}</div>{" "}
              <strong>
                {language == "ar" ? "جدولة موعد" : "Schedule an appointment"}
              </strong>
            </label> */}
            {/* {delivary_type == "time" ? (
              <input
                onChange={(e) => {
                  setorder_time(e.target.value);
                  ;
                }}
                style={{
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  padding: "10px",
                  outline: "none",
                }}
                id='date'
                name='date'
                type='date'
              />
            ) : null} */}
          </div>
        </div>
        <div className={language == "ar" ? "row" : "row rev_row"}>
          <div className="title">
            <h1>
              {language == "ar" ? "معلومات الدفع" : "payment information"}
            </h1>
            {/* <div className="icon-container">
              <FiEdit />
            </div> */}
          </div>
          <div className="content">
            <div className="checkBox-container">
              <label
                // onClick={() => {
                //   setpay_type(payCheckbox ? "cash_on_delivery" : "wallet");
                // }}
                class="checkBox"
              >
                <input
                  id="ch1"
                  type="checkbox"
                  checked={payCheckbox}
                  onChange={handlePayCheckboxChange}
                />
                <div class="transition"></div>
              </label>
              <div>
                <h6>
                  {language == "ar"
                    ? "الدفع نقدا عند الإستلام"
                    : "Payment in cash upon delivery"}
                </h6>
              </div>
            </div>
            {isThereIsToken ? (
              <>
                {" "}
                <div className="checkBox-container">
                  <label class="checkBox">
                    <input
                      id="ch2"
                      type="checkbox"
                      checked={payWalletBox}
                      onChange={handlePayUsingWalletBox}
                    />
                    <div class="transition"></div>
                  </label>
                  <div>
                    <h6>
                      {language == "ar"
                        ? "الدفع عن طريق المحفظة"
                        : "Payment using wallet"}
                    </h6>
                  </div>
                </div>
                <div className="checkBox-container">
                  <label class="checkBox">
                    <input
                      id="ch2"
                      type="checkbox"
                      checked={payTwoTypesBox}
                      onChange={handlePayTwoWaysBox}
                    />
                    <div class="transition"></div>
                  </label>
                  <div>
                    <h6>
                      {language == "ar"
                        ? "دفع جزء بالمحفظة"
                        : "Partial payment in wallet"}
                    </h6>
                  </div>
                </div>
              </>
            ) : null}
            {/* <div
              className='d-flex'
              onClick={handleOpenPayment}
              style={{cursor: "pointer"}}
            >
              <div className='icon'>{calendarTime}</div>{" "}
              <strong>
                {language == "ar"
                  ? "الدفع عن طريق البطاقة الأئتمانية"
                  : "Payment via credit card"}
              </strong>
            </div> */}
            <div className={`payment_method ${paymentOpen ? "active" : false}`}>
              <div className="input-form">
                <label htmlFor="">
                  {language == "ar" ? "حامل البطاقة" : "Card holder"}
                </label>
                <input
                  onChange={(e) => {
                    setCardInfo({
                      ...cardInfo,
                      user_card_name: e.target.value,
                    });
                  }}
                  type="text"
                  placeholder={
                    language == "ar" ? "حامل البطاقة" : "Card holder"
                  }
                />
              </div>
              <div className="input-form">
                <label htmlFor="">
                  {language == "ar" ? "رقم البطاقة" : "Card Number"}
                </label>
                <input
                  onChange={(e) => {
                    setCardInfo({
                      ...cardInfo,
                      card_number: e.target.value,
                    });
                  }}
                  type="text"
                  placeholder="000 000 000 000"
                />
              </div>
              <div className="d-flex">
                <div className="input-form">
                  <label htmlFor="">
                    {language == "ar" ? "تاريخ الانتهاء" : "End Date"}
                  </label>
                  <input
                    onChange={(e) => {
                      setCardInfo({
                        ...cardInfo,
                        end_date: e.target.value,
                      });
                    }}
                    type="text"
                    placeholder="00/00"
                  />
                </div>
                <div className="input-form">
                  <label htmlFor="">cvv</label>
                  <input
                    onChange={(e) => {
                      setCardInfo({
                        ...cardInfo,
                        cvv: e.target.value,
                      });
                    }}
                    type="text"
                    placeholder="000"
                  />
                </div>
              </div>
              <div className="checkBox-container">
                <label class="checkBox">
                  <input id="ch1" type="checkbox" />
                  <div class="transition"></div>
                </label>{" "}
                <div>
                  {language == "ar"
                    ? "حفظ البطاقه و استخدامها مرة اخري"
                    : "Save the card and use it again"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className='bottom'>
        <div className='title'>
          <h3>
            {language == "ar"
              ? "اختيارات المنتجات البديلة"
              : "Alternative product choices"}
          </h3>
          <p>
            {language == "ar"
              ? "في حال عدم توافر بعض المنتجات, كيف تفضل اختيار البدائل للمنتجات غير المتوفرة؟"
              : "If some products are not available, how do you prefer to choose alternatives for unavailable products?"}
          </p>
          <div className='content'>
            <div>
              <div
                style={{cursor: "pointer"}}
                onClick={() => {
                  setchoose_subs("info");
                }}
                className='checkBox-container'
              >
                <label className='checkBox'>
                  <input
                    type='checkbox'
                    checked={choose_subs === "info"}
                    onChange={() => handleCheckboxChange("option1")}
                  />
                  <div className='transition'></div>
                </label>{" "}
                <div>
                  <h6>{language == "ar" ? "ابلغني" : "Inform me"}</h6>
                </div>
              </div>
              <p>
                {language == "ar"
                  ? "سسيم إرسال لينك بالمنتجات البديلة عن طريق الواتساب."
                  : "Send a link to alternative products via WhatsApp."}
              </p>
            </div>
            <div>
              <div
                style={{cursor: "pointer"}}
                onClick={() => {
                  setchoose_subs("call");
                }}
                className='checkBox-container'
              >
                <label className='checkBox'>
                  <input
                    type='checkbox'
                    checked={choose_subs === "call"}
                    onChange={() => handleCheckboxChange("option2")}
                  />
                  <div className='transition'></div>
                </label>{" "}
                <div>
                  <h6>{language == "ar" ? "اتصل بي" : "Call me"}</h6>
                </div>
              </div>
              <p>
                {language == "ar"
                  ? "سيتصل بك أحد ممثلي خدمة العملاء لإبلاغك و اختيار البديل."
                  : "A customer service representative will contact you to inform you and choose a replacement."}
              </p>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};
